import React, { Component, Suspense } from 'react';
import LazyLoad from 'react-lazyload';

// Elements - Eagerly load the first section
import SliderOneSection from '../elements/home-slider/slider1';

// Lazy load other sections
const AboutUsOneSection = React.lazy(() => import('../elements/about-us-1'));
const ServicesSection = React.lazy(() => import('../elements/services-1'));
const ChooseUsSection = React.lazy(() => import('../elements/choose-us'));
const ProdajaNaslovna = React.lazy(() => import('./prodajaNaslovna'));

class Index extends Component {
	render() {
		return (
			<>
				{/* Eagerly loaded first section */}
				<SliderOneSection />
				<AboutUsOneSection />
				{/* Lazy-loaded sections with Suspense and viewport detection */}
				<Suspense fallback={<div className="loading"></div>}>
					<LazyLoad height={200} offset={100} placeholder={<div className="loading"></div>}>
						<ChooseUsSection />
					</LazyLoad>
					<LazyLoad height={200} offset={100} placeholder={<div className="loading"></div>}>
						<ServicesSection />
					</LazyLoad>
					<LazyLoad height={200} offset={100} placeholder={<div className="loading"></div>}>
						<ProdajaNaslovna />
					</LazyLoad>
				</Suspense>
			</>
		);
	}
}

export default Index;